const redirectToHRMProfile = (id: string) => {
  window.open(`${process.env.REACT_APP_HRM_PROFILE_ENDPOINT}/employee/${id}/info`, '_blank');
};

export default redirectToHRMProfile;
